export default {"src":"/_next/static/media/edit_pencil.1799ce6f.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};